import { render, staticRenderFns } from "./ViewActiveSyllabus.vue?vue&type=template&id=ed51c8f4&scoped=true"
import script from "./ViewActiveSyllabus.vue?vue&type=script&lang=js"
export * from "./ViewActiveSyllabus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed51c8f4",
  null
  
)

export default component.exports